'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ProvideProps2 = require('./ProvideProps');

var _ProvideProps3 = _interopRequireDefault(_ProvideProps2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Path = function (_ProvideProps) {
  (0, _inherits3.default)(Path, _ProvideProps);

  function Path() {
    (0, _classCallCheck3.default)(this, Path);
    return (0, _possibleConstructorReturn3.default)(this, _ProvideProps.apply(this, arguments));
  }

  Path.prototype.getProps = function getProps() {
    return {
      path: this.getPath()
    };
  };

  Path.prototype.renderEmptyChildren = function renderEmptyChildren(_ref) {
    var path = _ref.path;

    return _react2.default.createElement(
      'span',
      null,
      path
    );
  };

  return Path;
}(_ProvideProps3.default);

exports.default = Path;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-form-controlled/lib/Path.js
 ** module id = 1278
 ** module chunks = 0
 **/